<template>
  <div class="examineBox">
    <div class="containter" v-loading='loading'>
      <div class="listBox">
        <div style="display:flex;align-items:center;flex-wrap:wrap;padding:0 10px">
          <div class="batchBox mb-10">
            <div :class="['batchDelete',batchIndex==1?'active':'']" style="margin-left:0" @click="signEvent">盖章标记</div>
            <el-tooltip effect="dark" content="短信提醒业务人员拿结算单" placement="top-start">
              <div :class="['batchDelete',batchIndex==2?'active':'']" style="margin-left:0" @click="reminderEvent">短信提醒</div>
            </el-tooltip>
          </div>

          <label class="label_name mb-10">签约公司：</label>
          <el-select class="input mb-10" v-model="company" style="width:180px" size='mini' filterable placeholder="请选择签约公司" @change="getInvoiceList(1)" clearable>
            <el-option v-for="(item,index) in signCompanyList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>

          <label class="label_name mb-10">甲方名称：</label>
          <el-input class="mb-10" placeholder="请输入甲方名称" v-model.trim="customer_name" clearable @keydown.enter.native="customer_name?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="customer_name?getInvoiceList(1):''" style="padding:0 10px"></el-button>
          </el-input>

          <label class="label_name mb-10">申请序列号：</label>
          <el-input class="mb-10" placeholder="请输入申请序列号" v-model.trim="statements_seal_id" clearable @keydown.enter.native="statements_seal_id?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="statements_seal_id?getInvoiceList(1):''" style="padding:0 10px"></el-button>
          </el-input>

          <label class="label_name mb-10">结算单序列号：</label>
          <el-input class="mb-10" placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable @keydown.enter.native="statements_id?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="statements_id?getInvoiceList(1):''" style="padding:0 10px"></el-button>
          </el-input>

        </div>
        <el-table class="table" style="margin-top:5px;" ref="multipleTable" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 204px)" 
        border @selection-change="handleSelectionChange" row-key="statements_seal_id">
          <el-table-column type="selection" align="center" :selectable='checkSelectable' :reserve-selection="true" width="45" fixed="left" />
          <el-table-column prop="statements_seal_id" label="盖章序列号" align='center' width="84" />
          <el-table-column prop="statements_id" label="结算单序列号" align='center' width="94" />
          <el-table-column prop="order_amount" label="订单金额" align='center' width="90" />
          <el-table-column prop="customer_name" label="甲方名称" align='center' min-width="100" />
          <el-table-column prop="company" label="签约公司" align='center' min-width="100" />
          <el-table-column prop="applicant" align='center' label="申请人" width="80" />
          <el-table-column prop="applicant_time" align='center' label="申请提交时间" width="93" />
          <el-table-column prop="type" align='center' label="申请类型" width="145">
            <template slot-scope="{ row }">
              <span v-if="row.type == 1">含本公司结算单盖章</span>
              <span v-else-if="row.type == 2">仅客户公司结算单盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="verify_note" align='center' label="审核状态" width="100">
            <template slot-scope="{ row }">
              <span :style="{color: getVerifyNoteColor(row.verify_status)}">{{ row.verify_note }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_status" align='center' label="盖章状态" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.seal_status == 1" style="color:#00BB5D">已盖章</span>
              <span v-else-if="row.seal_status == 0">未盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_date" align='center' label="盖章日期" width="93">
            <template slot-scope="{ row }">
              <span>{{ row.seal_date || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_status" align='center' label="归档状态" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.file_status == 1" style="color:#00BB5D">已归档</span>
              <span v-else-if="row.file_status == 0">未归档</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_date" align='center' label="归档日期" width="93">
            <template slot-scope="{ row }">
              <span>{{ row.file_date || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作" fixed="right" width="160">
            <template slot-scope="scope">
              <button class="detailButton" v-if="scope.row.seal_status==1" style="background:#ff9b3b" @click="revokeInvoiced(scope.row)">撤销标记</button>
              <button class="detailButton" v-if="scope.row.seal_status!=1" @click="onClickSignRow(scope.row)">盖章标记</button>
              <button class="detailButton" @click="onClickDetailBtn(scope.row)">申请详情</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total" />
        </div>
      </div>
    </div>
    <el-dialog title="盖章标记" :visible.sync="signFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='loading'>
        <div class="dialogitem">
          <label style="font-size:14px"><em style="color:red">*</em>盖章日期：</label>
          <el-date-picker style="width:56%" v-model="timeDate" type="datetime" size="mini" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" class="signDate">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signFlag=false" size="mini">取 消</el-button>
        <el-button type="primary" @click="actualInvoiced" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getVerifyNoteColor } from '@/assets/js/tools.js'
export default {
  data () {
    return {
      statements_id: '',
      statements_seal_id: '',
      customer_name: '',
      page: 1,
      page_size: 50,
      total: 0,
      loading: false,
      accountList: [],
      invoice_id: '',
      multipleSelection: [],
      signFlag: false,
      timeDate: '',
      company: '',
      signCompanyList: [],
      invoiceFlag: false,
      invoiceLoading: false,
      verify_note: '',
      batchIndex: 1,
    }
  },
  created () {
    this.getSignCompanyList()
    this.getInvoiceList(1)
  },
  methods: {
    getVerifyNoteColor,
    revokeInvoiced (data) {//撤销标记
      this.$confirm('确定撤销此盖章标记？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.statementsSeal_sealAction, {
          statements_seal_id_list: [data.statements_seal_id],
          type: 2,
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.getInvoiceList(this.page)
            this.$message.success('操作成功')
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch((action) => {
      });
    },
    reminderEvent () {
      if (this.batchIndex == 1) {
        this.$refs.multipleTable.clearSelection();//清空用户选择
        this.batchIndex = 2;
        this.multipleSelection = [];
        return
      }
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择结算单',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定发送短信提醒吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.statementsSeal_remind, {
          statements_seal_id_list: this.multipleSelection.map(m => m.statements_seal_id),
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.$refs.multipleTable.clearSelection();//清空用户选择
            this.$message.success('提醒成功')
          } else {
            this.$message.warning(res.err)
          }
        }).catch(() => { this.loading = false })
      }).catch(() => {})
    },
    signEvent () {
      if (this.batchIndex == 2) {
        this.$refs.multipleTable.clearSelection();//清空用户选择
        this.batchIndex = 1;
        this.multipleSelection = [];
        return
      }
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择结算单',
          type: 'warning'
        })
        return
      }
      this.signFlag = true;
      this.handleGetTime()
    },
    actualInvoiced () {
      if (!this.timeDate) {
        this.$message({
          message: '请选择盖章日期',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.statementsSeal_sealAction, {
        statements_seal_id_list: this.multipleSelection.map(m => m.statements_seal_id),
        date: this.timeDate,
        type: 1,
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$refs.multipleTable.clearSelection();//清空用户选择
          this.getInvoiceList(this.page)
          this.signFlag = false
          this.timeDate = ''
          this.$message.success('操作成功')
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    checkSelectable (row) {
      if (this.batchIndex == 2) {
        return row.seal_status == 1
      } else {
        return row.seal_status == 0
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleCurrentChange (val) {
      this.getInvoiceList(val)
    },
    getInvoiceList (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_sealList, {
        params: {
          statements_seal_id: this.statements_seal_id,
          statements_id: this.statements_id,
          customer_name: this.customer_name,
          company: this.company,
          page: page,
          page_size: this.page_size,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSignCompanyList () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 1000
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    handleGetTime() {
      const date = new Date();
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1)
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
      const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
      const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
      const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
      this.timeDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async onClickSignRow(row) {
      this.$refs.multipleTable.clearSelection();//清空用户选择
      await this.$nextTick()
      this.$refs.multipleTable.toggleRowSelection(row);
      this.handleGetTime()
      this.signFlag = true;
    },
    onClickDetailBtn(row) {
      const routeData = this.$router.resolve({
        path: `/statementSealDetail/${row.statements_type}?seal_id=${row.statements_seal_id}&id=${row.statements_id}&enable_apply=${row.enable_apply ? row.enable_apply : ''}&sealType=${row.type}&action=1`,
      })
      this.$winopen(routeData.href)
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-date-editor .el-range-separator {
  width: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.signDate {
  /deep/.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #666;
  }
}
.label_name {
  font-size: 13px;
  margin-left: 8px;
  // line-height: 30px;
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding-top: 15px;
    margin-top: 10px;
    .topOperation {
      padding: 16px;
      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
      .selectBox {
        display: inline-block;
        vertical-align: middle;
        .selectItem {
          float: left;
          font-size: 13px;
          margin-left: 20px;
          cursor: pointer;
          .icon {
            width: 13px;
            height: 13px;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 3px;
          }
          &.active {
            .icon {
              border-color: #2662ff;
              position: relative;
              &::before {
                content: "";
                display: inline-block;
                width: 7px;
                height: 7px;
                background: #2662ff;
                border-radius: 1px;
                position: absolute;
                top: 2px;
                left: 2px;
              }
            }
          }
        }
      }
    }
  }
  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
  .detailButton {
    min-width: 60px;
    height: 22px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    border: none;
    padding: 0 3px;
  }
}
.batchBox {
  display: flex;
  align-items: center;
  margin-right: 15px;
  // margin-bottom: 15px;
  // margin: 15px 0;
  background: #ccc;
  border-radius: 4px;
  height: 28px;
  .batchDelete {
    width: 74px;
    height: 100%;
    line-height: 28px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &.active {
      border: 1px solid #2762ff;
      background: #2762ff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementSealAction.vue